import { Controller } from 'stimulus'
import CheckoutController from './checkout_controller'

export default class FormAccountController extends Controller {
  declare firstNameTarget: HTMLInputElement
  declare lastNameTarget: HTMLInputElement
  declare emailTarget: HTMLInputElement
  declare passwordTarget: HTMLInputElement
  static targets = ['firstName', 'lastName', 'email', 'password']

  declare checkoutOutlet: CheckoutController
  static outlets = ['checkout']

  connect() {
    this.firstNameTarget.focus()
    this.setInitialValues()
  }

  setInitialValues() {
    if (!this.checkoutOutlet.signupData.account) return
    const { first_name, last_name, email, password } =
      this.checkoutOutlet.signupData.account

    this.firstNameTarget.value = first_name
    this.lastNameTarget.value = last_name
    this.emailTarget.value = email
    this.passwordTarget.value = password
  }
}
